// extracted by mini-css-extract-plugin
export default {"content":"Mention-module__content--mcma0","container":"Mention-module__container--Z_xjH","animatedBackground":"Mention-module__animatedBackground--j5Pp6"};